var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinEstateOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C22.8701 0 29.25 6.37994 29.25 14.25C29.25 21.0341 24.5093 26.7109 18.1599 28.1484L15.7623 31.4058C15.4349 31.8506 14.8089 31.9458 14.3642 31.6184C14.283 31.5587 14.2113 31.487 14.1516 31.4058L11.736 28.1244C5.43897 26.6488 0.75 20.997 0.75 14.25C0.75 6.37994 7.12994 0 15 0Z",
    fill: "#48B864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.2104C22 20.6465 21.6518 21 21.2222 21H8.77778C8.34823 21 8 20.6465 8 20.2104V11.7727C8 11.5309 8.1091 11.3025 8.29606 11.1527L14.5183 6.16967C14.8007 5.94344 15.1993 5.94344 15.4817 6.16967L21.7039 11.1527C21.8909 11.3025 22 11.5309 22 11.7727V20.2104Z",
    fill: "#ECF5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEstateOnline);
export default __webpack_public_path__ + "static/media/pin-estate-online.4f192572ad0fd92c4492ea27e0b89b4d.svg";
export { ForwardRef as ReactComponent };